import { render, staticRenderFns } from "./webpunch.vue?vue&type=template&id=686d2d42&"
import script from "./webpunch.vue?vue&type=script&lang=js&"
export * from "./webpunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports